import { computed } from "vue";
import { DateTime } from "luxon";

export const recentTime = computed(() => {
  switch (new Date().getDay()) {
    case 1:
      return 72;
    case 7:
      return 48;
    default:
      return 24;
  }
});

/** Shared EAB recency rule for indicators and client-side filters. */
export function isRecentlyChanged(
  time: string | DateTime,
  recentHours = recentTime.value,
  now = DateTime.now(),
): boolean {
  const changedAt = typeof time === "string" ? DateTime.fromISO(time) : time;
  return changedAt.plus({ hours: recentHours }) > now;
}
